import type { ReactNode } from 'react'

import { Provider } from './modalContext'
type Props = {
  children: ReactNode
  onClose: () => void
}

const ModalProvider = ({ children, onClose }: Props) => (
  <Provider
    value={{
      onClose,
    }}
  >
    {children}
  </Provider>
)

export { ModalProvider }
